// extracted by mini-css-extract-plugin
module.exports = {"button":"Map_button__1DH9Z","active":"Map_active__1NCSN","body":"Map_body__3vT2J","show":"Map_show__3MQFr"};